import client from '../client';
import { getResponseValue } from 'util/validate';

export const _getApplicationSettings = async () => {
  const res = await client.get(`system/application-settings`, {}, { credentials: 'omit' });
  return await getResponseValue(res);
};

export const _upsertApplicationSettings = async (name, value) => {
  const res = await client.post(`system/application-settings`, { name, value }, { credentials: 'omit' });
  return await getResponseValue(res);
};
